export default [
{
"id": 1,
"nickname": "小美·716",
"userId": "1954365742",
"type": 3,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAzMTNfMTk1NDM2NTc0Ml8xX2hkMTg4Xzc3OQ==_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000277756247; userId=1954365742; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAE8-Ik1Tho61JgB2DkQzgsboJdrYHcNszVL8ZN_to2ThBkmo2rlxmmdZCy38mCAxWfY3SlCoaWf1AVyEJAaVmrQiS2p9371X-EPZSE2oZffZi1e_4IZ74zAq83pzhemDJJmUcWaMwuV0-zqIhTpoxSERnLM6ERP1fYQQLkpgVqZWvAmwHD9RQUeuTwghPlKOIx4t2A2BAHwJo2AKP8iye_yGhJEwYN8fze1y97CKEMszZ1sXx4iIEtym8YBDEtKWijv76_2JcgbLnTCB8Bto9cQnKul6BjFKAUwAQ; kuaishou.shop.b_ph=659f29f1fb36cc8f78ae1f89c951f7f46432; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAbRRKyzenCNYFhPE-9jZ6fPBjqjUBgb2Os_qzm5rwr1WoERCTjui-SoZLH-XGixw6ivMj_Hr_BPMyBz7QfAcx0ifEt1y8OEDFjyZdfHmD2QknbM9bxNK00HoOS-LDMedr416I1h83X5ymPewnmO62ohdu9ugd7quDSW3460GiAb8rEIGdTrqvKz8kF1yLoNr1jqyFI5jP6v7iJHShq7AqPbU2n4OjGJlnsPmKca8N43QGhKi1FaAfnwIV9YBgY4y89SVJA8iIFLNVKi_xcgVzVS4TTgYTEvChONGt4hIHiH8nexfnMwtKAUwAQ; kuaishou.ad.analysis_ph=c2e49086dc8b302097c6cddcb847e2e6c2a1\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 2,
"nickname": "娇妹儿",
"userId": "2131929203",
"type": 1,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/11/25/01/BMjAyNTExMjUwMTEwNDVfMjEzMTkyOTIwM18xX2hkOTNfMzAw_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000015505141; userId=2131929203; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFMmWWzas24xMhLAMQkdA691DZn7fKAwK7CN_CAXj7R3ad8XQ4xx88EM_KmWgtP3BMeZsyhh6RQOx5CGtO7DunZ3N7tBrMgtsUj1MksxpiOFUR3IWcrWWZykjm7Ge6dn6ljEK-XShvOhv2WtvXZ4han3gplw-VGoDuocmJo6RsNGMJNNAdJJzylwgFYekpKUIo5OkATesY7O5GmpXJDFc6IGhISqzP1A3OvUjEirVmZwcinEd4iIAelUm6GiDluVIleeeLPPwmEEkY3GaLwkqniBZnI51-dKAUwAQ; kuaishou.shop.b_ph=e28a1225a25b42061df616ac7bb7f2747862; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAWwRqcEMN92vsQAT6dslnTSTHwVUO5_hICPzA4sJTiId8nmX63XHwy71JA_CljRnX-gkB6Mx4dP-eA-rjwh5D-ctqumKXBrkzPggAY9OyV33gwiDl7dnHGsSOrm5IrDFlecbwXsJk79uo_ZZgY8uQuJ_QmzKr2HQzuIelHsG0Ocnu8qjjElPtlnsHz5NWm42R3fGvN5d2CMT5S0oUs5YrEmHsBpypIvLCGbbo5VdZXc5GhLJQvUwrfHcDOIi8qefbDJk8MYiIAtMwo5FY8f01KHT20OIy8aDOKoqSrQX1V_DJaA1_K7bKAUwAQ; kuaishou.ad.analysis_ph=8d240373968046c6869eb68585e4f902a0a2\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 3,
"nickname": "嘉文🌝•716",
"userId": "371800776",
"type": 2,
"img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/07/BMjAyNTEwMDQwNzQ1MTFfMzcxODAwNzc2XzFfaGQ3NV81NjI=_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 4,
"nickname": "金牌志虎🐯",
"userId": "8427947",
"type": 3,
"img": "https://p5-pro.a.yximgs.com/uhead/AB/2026/05/08/09/BMjAyNjA1MDgwOTUzMjRfODQyNzk0N18yX2hkNDkzXzk0NA==_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000010986245; userId=8427947; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFbDuMuavXxmrTeiUwp-R9o9xAZit6JxvbhrW5dWtvNxZBhK3BWPxwNs6yay7Eef6RA6mMcF37o9x5x275kDxQOAert2s6EKS5HWwjP6uFndEQG2eoFHcUKlNADiWqE-PzpA9ruKbcsuNsijzxGLwih-_b36N93FVBb0KMvumVuGPQH0Lal0AQKWSDUKLfipu6N7KN7zR41vU76N8frmS9eGhKbz3TbRj8_GqdtJns0FBl2yz4iIPAhpndMx3V2RcioGGigp3Y-m_sj6Rg91lhBTNc77IaFKAUwAQ; kuaishou.shop.b_ph=b63ce8f582fb48947df76f1b74670c0ff823; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAVwxGodiv64RbP8PYnMVVhUHuLc2F4FVEPn1Pd4-ZsVdMSO3ll4fxMvl_7s4E1cafTeIUYVp8EJ7XpodoYkmNQAzlzaWXWwhVwhgSbyCWjZzZH6gm6FKVkf5Pfo7eaKXhi7fVfuuz7tWJU-DPsPIEE1FYrVREjwU1YTgJhO5OJ7qQLlWWibjZKrXbPhm0UxMTGiJ4xj5TRav1v6tYwjqldQ5O2VNVS6AvGDmHZNkUA61GhLD0lY79lZNUc06quXcO9APrxoiICIYK1_Kvg2z66KgAjpnsHL6BPog_dCqOzjoQ_THTMpCKAUwAQ; kuaishou.ad.analysis_ph=f9935ffd5c5e452c70ef038501cf305b180f\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 5,
"nickname": "天启•716",
"userId": "331833119",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/18/BMjAyNTEwMDQxODM1MTVfMzMxODMzMTE5XzFfaGQxNzFfNDMy_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 6,
"nickname": "懵圈妹妹",
"userId": "16194648",
"type": 1,
"img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/06/22/13/BMjAyNTA2MjIxMzQ1MzVfMTYxOTQ2NDhfMV9oZDQwNl81NDQ=_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000002415749; userId=16194648; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHIB4DmrShtAv1mOD8aNSgm2L3r0ZBssFtHQ6Gfo_8UOZ7JCmjWmmgncJRWJQRop-wDsdf4tE7UKZGpihMNDxu_P7eJejA41TQYBpcc4aQZ2W4M2_BADyCa5mRE4Ts_tutgYrH1wnaBinfy63fNVh5x1Gwh9hVFen0aQQktdadAGcIekuTeO0N2LSMXnDQ7hB1gDZhZJbbp6fbZiPlUZwHyGhKWjgR0Z5KY20AASC-Mzxd_Ru4iIA2Omoaolh4wuExi6NwxUoq8jUwAavnlj9iNlxNkoPRWKAUwAQ; kuaishou.shop.b_ph=8ca9331b034411c97cd84a7e08cf10fcd86b; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAVLyfdTxp_nX7JU9XEfIsuniIoB90TqFxK0FLRJEgsBsTrnHScD_Ajx6NRBnSZM8E7TUjm5WRHKn17EzGYmEHqme72VVPRune9ZOJoGlvsoxeAobp54tjA_2RTMLAVBaTdVvT3trMhPs-V50_fqakEAdPimt_1t3ACa5f-xhLV4lRE_NEpC8TIbGdZwj7sHQJqBa4X-n8kV2i8ff59iBhfNRV1jOWIKNySIiyJV8cZ1GGhLBQhRfbrn6PLR9rKF_P-8CoiUiIGxZ0xYRkQ8NDVKG1A_RvNXCoWLsCkWoTR2ktq8ZYOIuKAUwAQ; kuaishou.ad.analysis_ph=0832aefa65fd04d6fbde1401e61680be66a9\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 7,
"nickname": "雅儿·716",
"userId": "73911771",
"type": 1,
"img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/05/19/BMjAyNTEwMDUxOTU5NTRfNzM5MTE3NzFfMV9oZDYxOF83NTU=_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000011566265; userId=73911771; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEzIWRsd26WIfoa99W8pBBWVkGQs-YJL7B3FUy0BDSD1HbbROUh9VSIXZ2Uc3n-N_9WDW0ZMrd8AMhJV2jxjLbwTxd_v-7vaFTlPwfoi09b7diD1S-Ivh7mUkhQD7CK7AAZInafbStXgPJf-6qekwtq9pSLbBFO_A2FK8bkJKfmgx7nJ9rK-lu-03GhmHQtGzl4vj1dMuOwCJs_cz5jhrJgGhKN9fDRK1YSjW3fqNnL2RrNsV0iINcLncFK4fStvivNE8RiBAMfRVH8d9FLTmKSp6Y7oEPGKAUwAQ; kuaishou.shop.b_ph=7576d602a02ffbd644cceb7fe0c11eaedeb8; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAcQOez8v0EbIlH01y9mM2_o9fptrKi5fYi-hdoF0eOmY_hgIshHrMRzAdPA_w8x384gESJdW6ACSaeJK43UVbVlJ_QtQNWAOFnlX0YmXU5wz4h19uf9OtlPcr3kiXNEIxzGtErDQO_m4Fg67VLt_w-gIqIIyhwHkbNaH82B-RmEQ_uRIQxmz09msDNoFzmWYVfgrNJNs7JbQL6jAhFtg-WHxRKwM616A7B6uHRlkYHYeGhIf-3QptSjo79alO4ig5LPGk-QiIL3mlNQM8fBzuYiOj7b5STu6lcut75xG7d6zT-QdlAffKAUwAQ; kuaishou.ad.analysis_ph=84f1d493597cf81388399b2d5d77959bcf8b\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 8,
"nickname": "陈小夫妇•716",
"userId": "29982331",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/14/BMjAyNTEwMDQxNDU0MDVfMjk5ODIzMzFfMV9oZDcyM183MTE=_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 10000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 9,
"nickname": "雪儿·716",
"userId": "11569700",
"type": 1,
"img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/14/BMjAyNTEwMDQxNDA2NTdfMTE1Njk3MDBfMV9oZDM0Xzg1NA==_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000011505740; userId=11569700; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFBYDPSV2MvHvdP_LSoLa8WAoDDyzP_-k6DSjA3PqK77H6JcRZyeR0LPe8Cc3wJcptPa2uW_VeDkyeqAS9DPu_bxYaMKfpJOq4wWjDgpqMFFqPAHP-FOsK32VTCWQGqchAQAh5v372n3eQ9LiUYjQENvraCVyo0vHnr4DvIAORM-76Cb4-NfZv_J-1-EUIl77VEBpPBsHWtmQ5EANILDRBrGhKbz3TbRj8_GqdtJns0FBl2yz4iIP8IpemXzwJv19oj44_e1_UPkiOH7xSDetU7rUcKRPEVKAUwAQ; kuaishou.shop.b_ph=f1d0f313db80eaafdc4c1e1845b766693f80; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAfTyfLqqnsJoCxwTgBNjRAuE1Lt3lEtQnXYPnKzTiedlKzcMJCJ2ezTdJbbSJ17apmpZUL6l9pWwhP1_7FpkvSuiFlo8x70JI9fNWqnQWUOvoKWke9RXai0r5ECq2f5zpZjOQt4cKnDVqMYwAQWz__W4j0s-fE_4saw8Gv6KzfL_zvYOhU4Row93uJDuHowLXICHv06Z-8cKAydxv_WnrVxXWSyzHF7eBycPAa13nOHfGhJfD1LIXix5VNQHFXrUrql1j9MiINtJ_mcudfthLxHB9_yYRBNzA7tBwin9m857HWsrRoIIKAUwAQ; kuaishou.ad.analysis_ph=9862d79e8210d18475c861cbd062987db59c\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 10,
"nickname": "依玥•716",
"userId": "228816049",
"type": 3,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/16/BMjAyNTEwMDQxNjE4MDNfMjI4ODE2MDQ5XzJfaGQ1NTBfNjYy_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000012466271; userId=228816049; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHqLxAJ6bkIE28SEjbnGieFSjJWQcSkHNNZMAFqqbxzJoFT4d-R_dk7lYiTsDyAjHyUW_HiJJrdGXJdSSGH_c87o-Af074kB93AL0rs1c7yMFJdptjeX6YxRMg4xhrEaew-s56XKpt7Vl3Y5G2l7OaqucEdH0EIUgReB9bgZQrLMQLE6YNCrMJYQiZ0UysHDgKGN3jhjG6bK55xmMzZrvDVGhIlYdGjF9dJg7vA1C954KBAdRAiIIYoY-U4lAeuR1BZafeNMd72v7UXgzqh1DVoMJ9bPJkHKAUwAQ; kuaishou.shop.b_ph=b96351b67f0db5c98d015b8463e4a7feecc6; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKgAQXas52-XJ7IvWkSlEahe7X71EF_FNT9BDk1ucwO13HAQ72hmRVlX-AelfQz0uY6b4VWSVBd-IFkzOx5L-JetFZFK5XlGznizVmrAOppDEUb91utV_vIISyUqi_Yn_AVrAy62qlKCYDWuMxSa1oHq7Y3DYECdCxWrTthxSteRynzghRlhKoK217qlVLHW0r9731E40rqeukm1-2tdYpa6Q4aEh_7dCm1KOjv1qU7iKDks8aT5CIgfs_bRjiSGsKsHuv3ckaIqKKh-QO-2n6C4Lr0bVtWaakoBTAB; kuaishou.ad.analysis_ph=703bbcce50a455851b0c54250baafed2cb79\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 11,
"nickname": "红妹•716",
"userId": "511012459",
"type": 1,
"img": "https://p5-pro.a.yximgs.com/uhead/AB/2025/10/04/16/BMjAyNTEwMDQxNjA0MzRfNTExMDEyNDU5XzJfaGQyODBfNjE2_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000011283039; userId=511012459; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEKgx8-JCGoTQxSeNOnsL8h1llkZgt7rUEk6c4bK-js8kii2ugXF8RKpDKyRTUDTOw3bQKI-8h-CHDekd3K-ijtR7G5pD_reVnMPhOSdm0dYF4Ifk4gwPqRWlLlAGM9JFsqEct2bWLsZogb7Psk-aNszuxEZ8rvT3WJElQQnlRZx7iG3650a-XF7XfSgwB8XBiEFecuxDOLjGR7MHdpL6VFGhJh6tisTTfHRh_4-Kis2knGVaQiINAXVKWLABPaanDSYtF4FRJy7HxCKO08yWUlyOnT5uG6KAUwAQ; kuaishou.shop.b_ph=cc803a3c6ec9ed5b7a1e4d3a83c633f35ed0; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAZr5dILzhOU78PhUEPWhpdmv3B2HwO1-HO23WxVrbUcg__fyGdFWglZ3SZ4kt9VUXHzJ4WV0brFYu0sBFRuZow0kPCby3qCtlmMnUvGFGxaGa8Vb5ZOiydZ_fdSuYdoeHvGqJ9R3dQHD0rw_hn81VdXz3U7uMDy0hz6iJyhj6XvoqbYAxth5XcA-xSbMi3mgsyaqp8VsWiYe4wCkxVFr-84wbwPSrrQgTtI_BrJOwzhzGhIdPiWvaF9nHFNZxi4p15Y47NUiILtmVWdJBZXKKuI971G4OoAWQE_iOVjvDuJyli1z0U1RKAUwAQ; kuaishou.ad.analysis_ph=ba3d3f5aed2e182a642fd0cd5151fcfc3dbf\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 12,
"nickname": "菲宝•716🐰",
"userId": "50913379",
"type": 3,
"img": "https://p5-pro.a.yximgs.com/uhead/AB/2026/03/16/21/BMjAyNjAzMTYyMTMxMDRfNTA5MTMzNzlfMV9oZDM4OV8yNTc=_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000006868736; userId=50913379; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAG6RAie6hXtIvPN_x-rupiovK1-Nxlo4Gj35uN1eM2PoFI49j8WOijVFYOhCP7GKmJD1tX6ndbRFZuoMxZVey-R30IK95kS1W5O7V4gPSD93o4-XBBbPNpKu47XVVpJlX5mvDR6ZUfcxt5ONsqje4iQE1W7f9Eu9zBP_5NMXBq_G_uFau9iCs29GcJ3LPKsO7-bp6DkA-He-YE-NMwiEaArGhKd_ML3fWEjTvpP6f9oisfIpAIiIK4D6q3wDYuXAKIa_2j0-Vk8J4YeL9QzvkazRA9voP_lKAUwAQ; kuaishou.shop.b_ph=eb9105a62a61ca44c23a60b0ae228fce0e01; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAY0tC4kCAT4Plh5sdPPk2OAgj869yrr3b7rWqe7J9gjZirIVRvgq3EQMgyAzbZSEkVPYaMoTuO3qmVE6zstDqIGf9kdIR7c1KQmGy9eluAU4JC2_uCvOIkIUKSsHwdx8pkvTN6rMtmyFp089a6Bq8irr9kHuGhZWGFsBpmd69rmpynXfseFjlMtYVw_z-Xiyb80vO3aVlePm8DAd7I8kCjxHb68R9BktOiZxPZwLk8ZeGhJHjsgHxsdoyFjPAaJV7bM6WXAiIFwsjPIShojWIpot1SxlxkTXnk5Qj8P4T2JlqG2cKOW-KAUwAQ; kuaishou.ad.analysis_ph=951e3b689eed066a92fc88719e991f052df2\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 13,
"nickname": "温柔曦•716",
"userId": "1256295378",
"type": 3,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTAwMjFfMTI1NjI5NTM3OF8xX2hkNTc2XzY2NQ==_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000014891048; userId=1256295378; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHAO0rvuXOJtOTbvuN3aiesgXzt3D5sdaKtqOLITDFiujxyqLqIqCewEO_rd2uH05Km0yFXR2xxTBB9Z4fSajDkuDsWxoycF0lTJSehML5_Ip7sZ7c1gVbXOyidObs24Sa_sf095ryeTNPipRLqpOBvttZ4RjT-vOPqth11TtAwIFYjETy1mzh19yW9JJzVcBdqE9QCuDW3m94z5nWbjYXzGhJSPwykspxJ_lwL1FDHlEAhP1IiIGn6gnlSucuttzPd1fI_ir3Cqen2m0T3xuW9aJ2ggMBAKAUwAQ; kuaishou.shop.b_ph=f34f45e334130754302af715ba46136c78cc; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAbZMXwXUicmlfWSzM3sEtT-uJqFlDJ7FFitgChnx-zutydAzj2WaMRVdXeAvIOy1tOHQZL6fBUnDl3oUoBAzmyiL7j_dpU0JkcULy7cs4KvqFRrHxRzU-MNcStUhsHNX5O2Y9it8ZBWoPYufNsSBYCQ4z1klDOX5MMojE3zktInQgTJ1plc5zAg3ZvQka6xYRImSEECsNCCDXKnL6qM28qzkIq6YOpxVxH6ju46LFTBtGhJTq2ODdjhJ6SRw9AjqUvtEh54iIA6x5wn4ZKoOdCiy3RIuVXGgyE6SVO4f-Fhlj0VTJ_-RKAUwAQ; kuaishou.ad.analysis_ph=83e2095fa3f1cc9d51a59406ef0bb3a37392\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 14,
"nickname": "奇妙冰•716",
"userId": "47532992",
"type": 3,
"img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/07/23/BMjAyNTEwMDcyMzQ1MThfNDc1MzI5OTJfMV9oZDE0MV8yNjY=_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000015113075; userId=47532992; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFSs4YDTtP8B_jrAZRYVwaqz6r6V679fO3OH_OfP2XeS6WLPh4NmxS-wNP_71Dw9gyEnEyfKuGnj8Ib16lZEipAHrZgKrZkXd5-URhDlQveyeoWtMjJgL_zXidZqlzZIjLi74FJ5eK-M4oy7n8lPAn53d5aPST7ss_G3JgPVBJsnX5S0gC7Fbh2mYjjSfxMIV2_3adrANpZteIwPMauXgJyGhJEwYN8fze1y97CKEMszZ1sXx4iIGZYTOvcbA5woCQgm2vKw0un3E5dD7yasX1qoY1Pqat8KAUwAQ; kuaishou.shop.b_ph=5e3025ff5ad5300871eb86b17ac60a8c633e; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAYBQAdp72IP3gd-MwPKGG4kgxX5m1G1Am5ay6dDyXvu2bGpOjucIfv0qvkJjt3hG5ecrQbMle-WeG3pRrZ7uJ0GkQIEiw04E15jG-SPPSKs5vJW7hJna_Ma4M4cQPu9kSpJQQ3NQHRpYhYrz9goIhYW3T4eL4sFpk_Whvx-PGfqtCd7_PIFGfpHCWDH2Qk7Sjdr7HHDRAzsDuf4eipQqkk3vtDT-QHdjTXHhWcGAzU-MGhK9VTAiWqq1_fIA0mCz5vd1yL4iIJy-p-PzTyMygFDiG9BZfuvQkw8tBPmAsBL-PwwiNTovKAUwAQ; kuaishou.ad.analysis_ph=5fb75030a81c67f2cd9a694644b4a50ae06f\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 15,
"nickname": "娜娜•雅儿",
"userId": "2454678977",
"type": 3,
"img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTEzNTlfMjQ1NDY3ODk3N18xX2hkMTIxXzU5_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000012465986; userId=2454678977; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFFFe5WEE3glV9ICnTlaqUvelQ2hiXfajCzPvulQ5EokTLitVcqTi1gHbbNsYkoIRBUCiTt3oBaeVWpkNhl9wE3DTwjhbETd7bu98LYDtWfYss-Xr-7U-7hfcjNJhmiWIJUBqIdGglCNYoyc02kj5j5r2eUE_uq_PdHfs4bHp9aK7TAAPHqadibfotSXcWEhwZRXb_AneNrUgDZrtbK_FcdGhIDc-qPTdpdt2c1Eu3bbve-xL4iIGj9y2fY56m8Sv3DfWg8XY2D4THn33MdjTVvAVbntHutKAUwAQ; kuaishou.shop.b_ph=4ca0912d223750f3a09d008562062ee0abf4; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAa_lYj4fRPwdg0x5sXQ250hAp07TnppoeTC8Ov5I0TaEUqJAQe9_m1eQrHq7j1KybRGu41vcv8BNJjPvrLD3jpLhq_QoozrD0yZn2bhGjkgYTe8-2nUcwpTOFY7QC0oKB1WbdSppTiIsD5N6XrZ8GnVfbf3p_HPdAM06HaXELhkHmB7WXYB8WGQnRbS_m_MuwU-u8BYoqV8TGCdomDAtysJ5WWE8QsTw6ZiXFHcaEThBGhKn8Lgzxz2mhe-DKrQUXPCtYAMiIMrji9VYN4naFx09QLaCwCMeKxMGF9IhGn1mwEFce02eKAUwAQ; kuaishou.ad.analysis_ph=61ff49b255057062e7167e9dac73dc885158\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 19,
"nickname": "兮妹儿·716",
"userId": "227811072",
"type": 1,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/13/BMjAyNTEwMDQxMzI0NTFfMjI3ODExMDcyXzFfaGQ2ODdfOTkx_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000011164851; userId=227811072; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEAUUwrcLCoWVmVDCOYDrbTCekpjlom_BMFdN_pBk6wDHTfymYlNO9BCeqtxQpmjDd3POMYxKB5fn-4pL8QShaDbKjjsuT89tyXFKMp9xsgr-Fzrdk4dCBPsLQwyAMCvpeenF06jAr6GpZSAdc-XvoZXbT5NYBNHC6XXnkIgyt5KY9b1aLP1DKm6iuALYfwesRTB-wrZGHi3kgvaaRW3N69GhI6AjZAm21RFhrJYP79BslttNciIHRbLW08L-g1L1IE6owJzY8N3R7Rvt0XQfGKzkgSqSwOKAUwAQ; kuaishou.shop.b_ph=ce4528c579632b19b9b5f846ee4a4b2916a0; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAWTaLNJM5NlsJLPxWDFPgLkUjrMheGhzgr3TLCxqMG82jM5mJYqiWI5T6o2SWXslHdlQVL0cXDq4k0OcaeR8gu15iY4YEROkKqgBkfjl8v_PraTMNMrzvETWO3lk0ZQPIcduurMK2dJgZNwHM0LqqJdfmXoodqb1p5PHceeC-v2FofmE7BYWpxyUNIwxQS6MHykvZejfmbJcgmpsGCFQOkEpZ8Lh0yGcMrumPokGdPMWGhLJQvUwrfHcDOIi8qefbDJk8MYiIOZ5HmtWIUiwZqhU9XzWZ3Gga1kQ24WBqeP0ik-tNhTtKAUwAQ; kuaishou.ad.analysis_ph=311c9cf4e6c1a6bf6e541e8ebbd65d9abf82\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 99999,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 22,
"nickname": "琪琪子•716",
"userId": "20229201",
"type": 3,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/12/09/08/BMjAyNTEyMDkwODA5MDFfMjAyMjkyMDFfMV9oZDYzM18xODY=_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000036306896; userId=20229201; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEnZvoxe53VVXDgZ9sLJZBN8QQkc1_TQyims-uwGlNGP2-o8bgpTrFDh8p4ynVV7OD-luPr5wrFHyWg749fGn_avGFg8T7LpxdXKDW_oZsOzwvHF3sJ94eb0l_r3rf6Hto-3YCW_LHYpI7K6k41QGVSj_XktQK_nRtOrcNcVXCfqz-FbaUnpgovuNLOzHphRKVDK-rU_7PpLLlrr3iUKtKIGhIoDb6opzlycuz0NgNjDyqUN2IiIBnI4Hzn2zXiQYjmXE1lTY71aDmL8BbT4QhII_QEo4QOKAUwAQ; kuaishou.shop.b_ph=ce51210fec0509d3de48ebaa3147e12d41ce; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwATC6i6ORkNS9ky5_3hbNt9nip3vElJ3bf2q1hlRKTw6AKpvwm4QeEctzHcUi85o8-BwdjALQy4DVBONGacOJIH7-W7wAJ0QQe7sBZ-7vAudSWfXyInFc25LU8OZzX-Bzy0gtF4Gz8gLBGTivss7YJ7Q8uCckb3E2EM8wrFYYmiu90mFlnQu6YQchVaD7WNUdSuL2_2PrPXNjQtuDcHZcQ6dtsGfD7Hx28vzsud6CD5MBGhI2Q4Zf7Fjy6K-OkplcWEkYXd8iIO8egvnKPdIlo0dJsGUO0mXL_IJGTtdLAvOxSI8i2eHDKAUwAQ; kuaishou.ad.analysis_ph=b75bd9d94d173dfff2521241499723a726cf\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 23,
"nickname": "辛洋•🐑",
"userId": "1289566627",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/11/25/18/BMjAyNTExMjUxODIwNTlfMTI4OTU2NjYyN18xX2hkNDIxXzM2Mg==_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 27,
"nickname": "一泽·716",
"userId": "641412925",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/15/BMjAyNTEwMDQxNTE0MTBfNjQxNDEyOTI1XzFfaGQ0MTJfMzcz_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 29,
"nickname": "牌晓亮·716",
"userId": "45672093",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/19/BMjAyNTEwMDUxOTEyMDNfNDU2NzIwOTNfMV9oZDE0M18xMTI=_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 30,
"nickname": "柏秋•716",
"userId": "5825207",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/17/BMjAyNTEwMDQxNzM0MTJfNTgyNTIwN18xX2hkNzgzXzM3NQ==_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 32,
"nickname": "甜妹·雅儿",
"userId": "3676208364",
"type": 3,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/18/BMjAyNTEwMDQxODI4MjlfMzY3NjIwODM2NF8yX2hkMTc2XzM2OQ==_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000435741931; userId=3676208364; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEa2TZNPXWeg0Ex7PrfROtbx2-DCYB_4_P0vOaIAOuBBSC2afb2LTIIcAOPdqNnLSM0qLfuTT5kV7iuq69WXHzl2Ny8NKPKpm1SJmh7KNuI5a4DQnWtrG5ZWNiu4M0XfLlecQs047nnTVYDHzXfRK7cSo1GFkowcrWEZ1iDYQIrTFtC-9tf6EH6VaZtVDerrYh4fzrk6RM9YcDvIgkH3-H2GhJOMw2bA-izRy5fvyc0gd4AwUQiIBrhVpbk6L9whCNA4FvCyCzE5ZrYXGuIgXDOlkrexm9JKAUwAQ; kuaishou.shop.b_ph=ad7ac18f8c8be03bff168b53045c2813bfe4; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAU7vk2-f2T8r716OWuNS4S_zJOAPo3fi1M1Xycsy-kLOEe1z3os59sfIZsLuNJFe_79FyOQcDsNdTIF5FUke10Hwm80E5_W9zmbfjXWLAdZErWq9Fj5gpwhyHDI0WjpuJ-n8pEMvt3MGLBHx_aBdrRpQXyOcrD_CS6gty_NTo3YWSyXxKazapkdFfPOX1_q1Vak2SOZoe2WGnIcm1OM-FJ5YhA_aNGkg3hfl0_fh1_cQGhLJQvUwrfHcDOIi8qefbDJk8MYiII-VRCJj-kErRd6vFX-WvQVRr6gU1xjZBMwUFUMUFIfmKAUwAQ; kuaishou.ad.analysis_ph=0dcf4d25a2f8897da3dbf2106c32a0736663\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 34,
"nickname": "扛刀baby·志虎",
"userId": "4187716321",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTA5NDRfNDE4NzcxNjMyMV8xX2hkMjI0XzQ0NQ==_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 35,
"nickname": "堇一•辛洋",
"userId": "2347908554",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/14/BMjAyNTEwMDUxNDE5MTJfMjM0NzkwODU1NF8xX2hkODBfMTQ5_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 39,
"nickname": "小欣·娇",
"userId": "709084778",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/08/00/BMjAyNTEwMDgwMDQ4NTFfNzA5MDg0Nzc4XzFfaGQ1NV8xNzk=_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 44,
"nickname": "小妮•辛洋",
"userId": "172766383",
"type": 3,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTE1MTBfMTcyNzY2MzgzXzFfaGQyNTVfMjU1_s.jpg",
"cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000470983838; userId=172766383; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFN48D4ENCQ-MnMdG1Dxmj-F18Y0CJ8loLbOXHPYWlXZI2LW5EZK-1sDFhZFesZKt5PofuO0ccPLV5Q3VCGQ5Y5oo6Wm9PI-_RqTUqe15pptNOjkHrrIF3wlCRZ4YZXDmEIwIjRmwOQWq7WoyQWfKwVlFMmsJyD0I9F6Ep0CnoJNuSAcbw199sc5HEu2SC4jds8nP9ev8GVNQEG5taqUxRkGhI2yYASXgUPN_H6NBCr-rCyOd4iIBL7Nrx2lMtJCOYNwJo0fH8XnOl1SZer35PNChxxjV7qKAUwAQ; kuaishou.shop.b_ph=eee7713c04be2ee81c7182923bc22a39713a; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAa3WTyhSwuUM0IyCwJIVqk4fvwRCBSh93sYeoOJAVI7RM7h54R5VZCSiVAFCZbtr7P2pS5mHaTpayXh9O_yFLebXgnGLzI4etSljyUalcvWLezgMJHfEqx4Cs6wwAIYPCEC8Mjs5KXbf6aHDUaZM-y9BOQE0EmenL9MWxEZ-UB45guqDIvvOChOgqnBxXHmPC5AjIMKCJt4rDzjCxkiTELQiGU7QMzWub3t7Ir7AitSoGhLJQvUwrfHcDOIi8qefbDJk8MYiIHqhvbQF_-o-lREerYQigZ5e-9zqAk5a_YZC7IFHZzIZKAUwAQ; kuaishou.ad.analysis_ph=97fdb8fb156f95c0085147b3b5b9d1bb5bd7\n",
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 50,
"nickname": "子画·志虎",
"userId": "1391295492",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/19/BMjAyNTEwMDQxOTEyMzBfMTM5MTI5NTQ5Ml8xX2hkNTQzXzI2NQ==_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 10000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 53,
"nickname": "顾洋•716",
"userId": "1135009365",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTA2MjZfMTEzNTAwOTM2NV8xX2hkNjYwXzY2_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 10000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 54,
"nickname": "虎牙妹妹•亮",
"userId": "1392669964",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/08/03/BMjAyNTEwMDgwMzM5NTNfMTM5MjY2OTk2NF8xX2hkODM4XzQwMg==_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 600000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
{
"id": 76,
"nickname": "困困·辛洋",
"userId": "4339498161",
"type": 2,
"img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/07/20/BMjAyNTEwMDcyMDA3MTZfNDMzOTQ5ODE2MV8xX2hkMjQ3XzU5Nw==_s.jpg",
"cookie": null,
"gmvTodayAmountDouble": 0,
"diveAmount": 10000,
"giftTodayAmountDouble": 0,
"createTime": 1744725047000
},
]


// WEBPACK FOOTER //
// ./src/components/page260618/data-30.js